import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { XIcon } from "@phosphor-icons/react/dist/icons/X";
import { CustomModalProps } from "../../lib/types/Overlays.ts";
import { twMerge } from "tailwind-merge";

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  className = "",
  closeOnBackdrop = true,
  hideCloseBtn = false,
  stickyHeader = false,
}: CustomModalProps) => {
  return (
    isOpen && (
      <Dialog
        open={isOpen}
        onClose={(value) => {
          if (closeOnBackdrop && onClose) onClose(value);
        }}
        className="flex-center relative z-[999]"
      >
        <DialogBackdrop className="fixed inset-0 -z-10 bg-black/50" />
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <DialogPanel
            onClick={(e) => e.stopPropagation()}
            className={twMerge(
              `inset-0 z-50 max-h-[90vh] w-full rounded-xl bg-gray-600 p-6 sm:container`,
              // Fixed header: the panel itself no longer scrolls, the body does.
              stickyHeader ? "flex flex-col overflow-hidden" : "overflow-y-auto",
              className
            )}
          >
            <div className="mb-4 flex shrink-0 items-center justify-between gap-4">
              {title && (
                <DialogTitle className="text-lg font-normal text-gray-200">
                  {title}
                </DialogTitle>
              )}
              {!hideCloseBtn && (
                <XIcon
                  className="h-5 w-5 cursor-pointer text-gray-200 hover:stroke-2"
                  onClick={onClose}
                />
              )}
            </div>
            <div className={twMerge("text-gray-200", stickyHeader && "-mx-6 min-h-0 flex-1 overflow-y-auto px-6")}>
              {children}
            </div>
          </DialogPanel>
        </div>
      </Dialog>
    )
  );
};

export default Modal;
